import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card, CardBody,
  Container, Row, Col,
} from "reactstrap";
import { businessesRepo } from "data/repositories/businessesRepo";
import { bookingsRepo } from "data/repositories/bookingsRepo";
import StatCard from "components/StatCard";

export default function PartnerHome() {
  const [bizCount, setBizCount] = useState(0);
  const [bookingCount, setBookingCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    const biz = businessesRepo.list();
    const bk = bookingsRepo.list();
    setBizCount(biz.length);
    setBookingCount(bk.length);
    setPendingCount(bk.filter((b) => b.status === "pending").length);
  }, []);

  return (
    <>
      <div className="header bg-gradient-warning pb-6 pt-5 pt-md-7">
        <Container fluid>
          <h2 className="text-white mb-0">Partner Paneli</h2>
          <p className="text-white opacity-8">İşletmelerinizi ve rezervasyonlarınızı yönetin</p>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Row className="mb-4">
          <Col lg={4} md={6} xs={12} className="mb-3">
            <StatCard title="İşletmelerim" value={bizCount} icon="fas fa-store" color="primary" />
          </Col>
          <Col lg={4} md={6} xs={12} className="mb-3">
            <StatCard title="Toplam Rezervasyon" value={bookingCount} icon="fas fa-calendar-check" color="success" />
          </Col>
          <Col lg={4} md={6} xs={12} className="mb-3">
            <StatCard title="Bekleyen" value={pendingCount} icon="fas fa-clock" color="warning" />
          </Col>
        </Row>

        <Row>
          <Col md={6} className="mb-3">
            <Card className="shadow" tag={Link} to="/admin/partner/businesses" style={{ textDecoration: "none" }}>
              <CardBody className="text-center py-4">
                <i className="fas fa-store fa-2x text-primary mb-2" />
                <h4>İşletmelerimi Yönet</h4>
              </CardBody>
            </Card>
          </Col>
          <Col md={6} className="mb-3">
            <Card className="shadow" tag={Link} to="/admin/partner/bookings" style={{ textDecoration: "none" }}>
              <CardBody className="text-center py-4">
                <i className="fas fa-calendar-alt fa-2x text-success mb-2" />
                <h4>Rezervasyonları Yönet</h4>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
